import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';

import { TranslatePipe } from '@next/core-lib/i18n';

import { FecalScoringDetailPenScoreFormComponent } from '../fecal-scoring-detail-pen-score-form/fecal-scoring-detail-pen-score-form.component';

@Component({
  selector: 'app-fecal-scoring-detail-pen-form',
  templateUrl: './fecal-scoring-detail-pen-form.component.html',
  styleUrls: ['./fecal-scoring-detail-pen-form.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatSuffix,
    NgIf,
    MatError,
    FecalScoringDetailPenScoreFormComponent,
    MatButton,
    MatIcon,
    TranslatePipe,
  ],
})
export class FecalScoringDetailPenFormComponent {
  @Input() isMobile: boolean;
  @Input() penFormGroup: FormGroup;
  @Input() index: number;
  @Input() canDelete: boolean;

  @Output() deletePen = new EventEmitter<number>();

  constructor() {}

  public delete() {
    this.deletePen.emit(this.index);
  }
}
